
// ダッシュボードUI開発用のモックデータ

// 1段目カード用のサマリーデータ
export const dashboardSummary = {
  plan_name: "ビジネスプラン",
  period_start: "2026/05/01",
  period_end: "2026/05/31",
  current_month_total: 842,
  overage_count: 342,
  reserved_count: 18,
  next_schedule_at: "本日 18:00",
  active_members: 7,
};

// 2段目グラフ用の月次データ
export const monthlyChartData = {
  labels: Array.from({ length: 31 }, (_, i) => `${i + 1}`), // 1日から31日までのラベル
  data: Array.from({ length: 31 }, (_, i) => ({
    day: i + 1,
    success: Math.floor(Math.random() * 80) + 10, // 10〜89件
    failed: Math.floor(Math.random() * 5),       // 0〜4件
    reserved: Math.floor(Math.random() * 20) + 5,   // 5〜24件
  })),
};

// 3段目左カード用のエラー履歴
export const recentErrors = [
  { time: "2026/5/25 14:22", code: "CF101", summary: "必須のヘッダーが不足しています" },
  { time: "2026/5/24 09:15", code: "CV205", summary: "unit_amountは0以上の数値である必要があります" },
  { time: "2026/5/24 08:30", code: "API404", summary: "顧客IDが見つかりません: cus_xxxxxxxx" },
  { time: "2026/5/23 18:01", code: "AU403", summary: "この操作を実行する権限がありません" },
  { time: "2026/5/22 11:45", code: "CF102", summary: "リクエストボディの形式が正しくありません" },
];
// エラー0件の場合のテスト用
// export const recentErrors = [];


// 3段目右カード用の操作アクティビティ
export const recentActivities = [
  { user: "Mori", action: "請求書CSVアップロード", time: "2026/5/25 10:00" },
  { user: "Tanaka", action: "顧客データを更新しました", time: "2026/5/25 09:30" },
  { user: "Mori", action: "ログイン", time: "2026/5/25 09:00" },
  { user: "Sato", action: "予約請求をキャンセルしました", time: "2026/5/24 18:00" },
  { user: "Mori", action: "税率設定を更新しました", time: "2026/5/24 15:20" },
];

// 4段目のお知らせ
export const announcements = [
  { date: "2026-05-20", content: "【メンテナンス】2026年6月15日の午前2時から午前4時まで、システムメンテナンスを実施します。" },
  { date: "2026-05-01", content: "【機能追加】新しいダッシュボード機能が利用可能になりました。" },
  { date: "2026-04-15", content: "【お知らせ】CSVアップロード時の仕様を一部変更しました。詳細はマニュアルをご確認ください。" },
];

